import React from 'react';

/**
 * FreeTextField - Optional free-text textarea
 *
 * Appears at the bottom of each step for users to add additional details
 * beyond the checkbox items.
 */
export function FreeTextField({
  value,
  onChange,
  placeholder = 'Er det noe annet du vil legge til?',
  label = 'Tilleggsopplysninger',
  maxLength = 2000,
}) {
  const characterCount = value?.length || 0;
  const isNearLimit = characterCount > maxLength * 0.9;

  return (
    <div className="mt-6">
      <label
        htmlFor="free-text"
        className="block text-sm font-medium text-text-secondary mb-2"
      >
        {label} <span className="text-text-muted font-normal">(valgfritt)</span>
      </label>

      <textarea
        id="free-text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={4}
        className="
          w-full p-4 rounded-lg
          border border-border-light
          bg-white
          text-text-primary
          placeholder:text-text-muted
          focus:outline-none focus:ring-2 focus:ring-sage-300 focus:border-sage-400
          transition-all duration-200
          resize-y
          min-h-[100px]
        "
      />

      {/* Character count */}
      <div className="flex justify-end mt-1">
        <span
          className={`text-xs ${
            isNearLimit ? 'text-warning-500' : 'text-text-muted'
          }`}
        >
          {characterCount} / {maxLength}
        </span>
      </div>
    </div>
  );
}

export default FreeTextField;
